import { endpoints } from "../config";
import { deleteData, getData, postData, putData } from "./api-utils";

const getUser = async () => {
  return await getData(endpoints.user);
};

const getUserBySchool = async (schoolId) => {
  return await getData(endpoints.user + "?school=" + schoolId);
};

const postUser = async (values) => {
  return await postData(endpoints.user, values);
};

const updateUser = async (values, userId) => {
  return await putData(endpoints.user + "/" + userId, values);
};

const deleteUser = async (userId) => {
  return await deleteData(endpoints.user + "/" + userId);
};

const recoverUser = async (password, userId) => {
  return await postData(endpoints.userRecover + "/" + userId, password);
};

const getUserCredit = async (userId) => {
  return await getData(endpoints.userCredit + "/" + userId);
};

const updateUserCredit = async (values, userId) => {
  return await postData(endpoints.userCredit + "/" + userId, values);
};

const deleteUserCredit = async () => {};

const postUserToGroup = async (userId, groupId) => {
  return await postData(endpoints.userGroup, { userId, groupId });
};

const deleteUserToGroup = async (userId, groupId) => {
  return await deleteData(
    endpoints.userGroup + `?userId=${userId}&groupId=${groupId}`
  );
};
const getDrivingTime = async (userId) => {
  return await getData(endpoints.drivingTime + "/" + userId);
};
const postDrivingTime = async (values) => {
  return await postData(endpoints.drivingTime, values);
};
const updateDrivingTime = async (recordId, values) => {
  return await putData(endpoints.drivingTime + "/" + recordId, values);
};
const deleteDrivingTime = async (recordId, userId) => {
  return await deleteData(
    endpoints.drivingTime + "/" + recordId + "/" + userId
  );
};

export {
  getDrivingTime,
  updateDrivingTime,
  postDrivingTime,
  deleteDrivingTime,
  getUser,
  postUser,
  updateUser,
  deleteUser,
  getUserCredit,
  updateUserCredit,
  deleteUserCredit,
  recoverUser,
  getUserBySchool,
  postUserToGroup,
  deleteUserToGroup,
};
